<label class="flex items-center cursor-pointer">
  <span class="order-2 font-dinosaur text-base" [class.mr-2.5]="labelPosition === 'left'" [class.ml-2.5]="labelPosition === 'right'" [class.order-1]="labelPosition === 'left'">{{ label }}</span>
  <div class="order-1" [class.order-2]="labelPosition === 'left'">
    <img class="h-4 w-4" src="./assets/icons/radio-checked.svg" alt="Sim" *ngIf="checked" />
    <img class="h-4 w-4" src="./assets/icons/radio-unchecked.svg" alt="Não" *ngIf="!checked" />
  </div>
  <input type="radio" class="hidden" (change)="handleRadioChange($event)" [value]="value" [name]="name"/>
</label>
